import { render, staticRenderFns } from "./collateral-organization-select-widget.vue?vue&type=template&id=146f2e22&"
import script from "./collateral-organization-select-widget.vue?vue&type=script&lang=js&"
export * from "./collateral-organization-select-widget.vue?vue&type=script&lang=js&"
import style0 from "./collateral-organization-select-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports